export enum SheetType {
  BUDGET = 'budgets',
  ACCOUNTING = 'accountings',
  SPREADSHEET = 'spreadsheets',
}
